import React from "react";
import "./Books.css";
import { Link } from "react-router-dom";
const Books = (props) => {
  return (
    <div>
      <Link
        to={"/catalogue/" + props.content.book_id + "/" + props.content.title}
      >
        <div className="bookContainer  bookPadding">
          <img src={props.content.image} className="image" alt="book" />
          <div className="overlayBook">
            <p>
              <span className="bookTitle">{props.content.title}</span>
              <br />
              <span>CLASS</span> - {props.content.Class}
              <br />
              <span>EDITION</span> - {props.content.edition}
              <br />
              <span>PRICE</span> : ₹ {props.content.price}
            </p>
          </div>
          <div className="bookInfo">
            <p className="title-container">
              <span className="title">{props.content.title}</span>
              <br />
              <span>CLASS</span> - {props.content.Class}
              <br />
              <span>EDITION</span> - {props.content.edition}
              <br />
              <span>PRICE</span> : ₹ {props.content.price}
            </p>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default Books;
